import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Form, Col } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import axios from "axios";
import Select from 'react-select'

export default function CustomerHostsModal(props) {

    const [selectCustomerConfig, setSelectCustomerConfig] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState({});

    const initialValues = {
        domain: '',
        host: '',
        user: '',
        password: '',
        comment: '',
    };
    const saveNew = (values) => {
        let body = values;
        body.customer_id = selectedCustomer.value;
        return axios.post(process.env.REACT_APP_API_URL + '/api/hosts', body);
    };
    const updateExisting = (values) => {
        let body = values;
        body.customer_id = selectedCustomer.value;
        return axios.put(process.env.REACT_APP_API_URL + '/api/hosts/' + props.edit, body);
    };


    const fetchAllCustomers = () => {
        axios.get(process.env.REACT_APP_API_URL + '/api/customers').then(({ data }) => {
            mapCustomersForSelect(data);
        }).catch(e => props.onSubmit());
    };
    const fetchEntry = () => {
        axios.get(process.env.REACT_APP_API_URL + '/api/hosts/' + props.edit).then(({ data }) => {

            setSelectedCustomer({ label: data.customer_short.name, value: data.customer_short.id })

            formik.setFieldValue('domain', (data.data.domain == null ? '' : data.data.domain));
            formik.setFieldValue('host', (data.data.host == null ? '' : data.data.host));
            formik.setFieldValue('user', (data.data.user == null ? '' : data.data.user));
            formik.setFieldValue('password', (data.data.password == null ? '' : data.data.password));
            formik.setFieldValue('comment', (data.data.comment == null ? '' : data.data.comment));
        }).catch(e => props.onSubmit());
    };
    const deleteData = () => {
        axios.delete(process.env.REACT_APP_API_URL + '/api/hosts/' + props.edit).then((d) => {
            toast.success("Gelöscht");
            props.onSubmit();
        }).catch(e => {
            toast.error("Es ist ein Fehler aufgetreten oder du bist für diese Aktion nicht berechtigt. Versuche es erneut oder wende dich an einen Administrator.", { autoClose: 5500 });
            props.onSubmit();
        });
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            domain: Yup.string().required(),
            host: Yup.string(),
            user: Yup.string(),
            password: Yup.string(),
            comment: Yup.string()
        }),
        onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {

            setSubmitting(false);
            if (props.edit === 0) {
                saveNew(values).then(d => { toast.success("Gespeichert"); resetForm(); props.onSubmit() }).catch(e => console.log(e));
            } else {
                updateExisting(values).then(d => { toast.success("Gespeichert"); resetForm(); props.onSubmit() }).catch(e => console.log(e));
            }
            setSubmitting(true);

        },
    });


    const mapCustomersForSelect = (data) => {
        let options = data.map((item, i) => {
            return { label: item.name, value: item.id };
        });
        setSelectCustomerConfig(options);
    };

    useEffect(() => {
        fetchAllCustomers();
    }, []);

    useEffect(() => {
        if (props.edit !== 0)
            fetchEntry();
    }, [props.edit]);

    useEffect(() => {
        if (props.edit === 0 && props.customer !== undefined)
            setSelectedCustomer({ label: props.customer.name, value: props.customer.id })
    }, [props.edit, props.customer]);

    const renderForm = () => {
        return <Form onSubmit={formik.handleSubmit} className={`bg-white position-relative`}>
            <Modal.Body>
                <div className="row">
                    <div className="col-xl-6">

                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Kunde</Form.Label>
                                <Select options={selectCustomerConfig} value={selectedCustomer} onChange={(o) => {
                                    setSelectedCustomer(o);
                                }}
                                    classNamePrefix="sl2def"
                                    className={Object.keys(selectedCustomer).length <= 0 && 'select2-has-error'}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Domain</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Domain"
                                    name="domain"
                                    value={''}
                                    {...formik.getFieldProps("domain")}
                                    isInvalid={formik.errors.domain}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Host</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Host"
                                    name="host"
                                    value={''}
                                    {...formik.getFieldProps("host")}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>User</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="User"
                                    name="user"
                                    value={''}
                                    {...formik.getFieldProps("user")}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Passwort</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Passwort"
                                    name="password"
                                    value={''}
                                    {...formik.getFieldProps("password")}
                                />
                            </Form.Group>
                        </Form.Row>
                    </div>
                    <div className="col-xl-6">
                        <Form.Row style={{ height: '100%' }}>
                            <Form.Group as={Col} className="d-flex flex-column">
                                <Form.Label>Kommentar</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Kommentar"
                                    name="comment"
                                    className="flex-grow-1"
                                    value={''}
                                    {...formik.getFieldProps("comment")}
                                />
                            </Form.Group>
                        </Form.Row>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="submit">Speichern</Button>
                <Button variant="default " onClick={props.onHide}>Schließen</Button>
            </Modal.Footer>
        </Form>
    }

    const deleteForm = () => {
        return <>
            <Modal.Body>
                <p>Bist du dir sicher dass du diese Zugangsdaten löschen möchtest?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={deleteData}>Ja, Daten löschen</Button>
                <Button variant="default " onClick={props.onHide}>Nein, Daten nicht löschen</Button>
            </Modal.Footer>

        </>
    }

    return <>
        <Modal
            show={props.show}
            size={(props.type && props.type === 'delete') ? ' md' : 'xl'}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Host Zugangsdaten
                    {
                        (props.type && props.type === 'delete') ? ' löschen' :
                            (props.edit === 0) ? ' erstellen' : ' bearbeiten'
                    }
                </Modal.Title>
            </Modal.Header>
            {(props.type && props.type === 'delete') ? deleteForm() : renderForm()}
        </Modal>
    </>

}